import React, { FC } from 'react';
import Pdf from 'react-native-pdf';

import Image from '@components/common/ImageOverlay';
import Preview from '@components/imageHandling/components/thumbnails';
import { ImagesContainerMode } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';

import { ImageWrapper, type ImageWrapperProps } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ImageWrapper';
import type { ImageItem } from '@components/machines/components/detailsComponents/activeMachine/components/Images/types';

export interface ImagesRenderProps
  extends Pick<
    ImageWrapperProps,
    | 'C'
    | 'isImageHandlingNavigation'
    | 'documentRetrieveId'
    | 'documentRetrieveKey'
    | 'panelViewMode'
    | 'scale'
    | 'onImagePress'
    | 'shouldDisplayFavorites'
  > {
  images: ImageItem[];
  mode?: ImagesContainerMode;
}

export const ImagesRender: FC<ImagesRenderProps> = (props) => {
  const {
    images,
    C,
    isImageHandlingNavigation,
    documentRetrieveId,
    documentRetrieveKey,
    panelViewMode,
    scale,
    onImagePress,
    shouldDisplayFavorites,
    mode,
  } = props;

  return (
    <>
      {images.map((i, index) => (
        <ImageWrapper
          key={i.id}
          C={C}
          isImageHandlingNavigation={isImageHandlingNavigation}
          documentRetrieveId={documentRetrieveId}
          documentRetrieveKey={documentRetrieveKey}
          panelViewMode={panelViewMode}
          scale={scale}
          index={index}
          onImagePress={onImagePress}
          id={i.contentHash}
          shouldDisplayFavorites={shouldDisplayFavorites}
          links={i.links}
        >
          {i.isPreview || i.isDocument ? (
            <Preview small={mode === ImagesContainerMode.ROW} machineList={true} fontName="Subhead 2" item={i} />
          ) : i.type === 'application/pdf' || (i.file && i.file.type === 'application/pdf') ? (
            <Pdf source={{ uri: i.urlSmall || i.file }} style={{ width: '100%', height: '100%' }} />
          ) : (
            <Image
              source={{ uri: i.base64 || i.urlSmall || i.uri }}
              rotate={i?.customRotate?.[i?.pageNumber] || 0}
              style={{ width: '100%', height: '100%' }}
              resizeMode="contain"
              C={C}
            />
          )}
        </ImageWrapper>
      ))}
    </>
  );
};
